import { SearchIcon } from 'lucide-react'
import React, { useEffect } from 'react'
import { searchOptionsOrder } from '../../utils/static/static'
import classes from './OrderList.module.css'
import PopUp from './PopUpDropdown/PopUp'

const SearchBar = ({ search, setSearch }) => {
    const onChange = (value) => {
        setSearch((prev) => ({ ...prev, searchBy: value }))
    }

    useEffect(() => {
        if (search.value.length <= 0) {
            setSearch((prev) => ({
                ...prev,
                isSearchAble: false,
            }))
        }
    }, [search.value])
    return (
        <div className={classes.searchContainer}>
            <div className={classes.searchInputWrapper}>
                <div className={classes.searchIconWrapper}>
                    <SearchIcon className={classes.searchIcon} size={20} />
                </div>
                <input
                    type="text"
                    placeholder="Search Your Product....."
                    value={search.value}
                    onChange={(e) => setSearch((prev) => ({ ...prev, value: e.target.value, isSearchAble: true }))}
                    className={classes.searchInput}
                />
                <div className={classes.popup}>
                    <PopUp
                        options={searchOptionsOrder}
                        parentClass=""
                        defaultValue={searchOptionsOrder[0]}
                        placeholder=""
                        filters={''}
                        onChange={onChange}
                    />
                </div>
            </div>
        </div>
    )
}

export default SearchBar
